<template>
    <div class="account-statement">
        <form @submit.prevent="getData" class="main-form">
            <date-picker 
                v-model="requestParams.StartDate"
                :title="$t('WEBSHOPS__START_DATE')"
                @clear="requestParams.StartDate = ''"
            />
            <date-picker 
                v-model="requestParams.ToDate"
                :title="$t('WEBSHOPS__TO_DATE')"
                @clear="requestParams.ToDate = ''"
            />
            <button class="btn">{{ $t('WEBSHOPS__SEARCH') }}</button>
        </form>
        <div class="loader" v-show="loading"></div>
        <grid
            v-show="!loading"
            fullGrid
            :passedData="gridData"
            :columns="columns"
            :passedCount="dataCount"
            :passedPageSize="10"
            @pageChanged="pageChangeHandler"
        />
    </div>
</template>

<script>
import DatePicker from '@/components/ReusableComponents/DatePicker/DatePicker.vue'
import Grid from '@/components/ReusableComponents/Grid/Grid.vue'
import axios from '@/Helpers/AxiosInstance.js'
import { getDateString, subtractHours } from '@/Helpers/HelperFunctions.js'
export default {
    components: {
        DatePicker, Grid,
    },
    props: {
        webshopID: {
            type: Number,
            required: true,
        },
        webshopCurrency: String,
    },
    created() {
        this.requestParams.WebShopId = this.webshopID
        this.getData()
    },
    data() {
        return {
            requestParams: {
                WebShopId: '',
                StartDate: '',
                ToDate: '',
                CurrentPage: 1,
                PageSize: 10,
            },
            columns: [
                {
                    title: this.$t('WEBSHOPS__CREATION_DATE'),
                    key: 'createDate',
                    customTemplate: (item, val) => getDateString(val, 'yyyy-MM-dd HH:mm'),
                },
                {
                    title: this.$t('WEBSHOPS__TYPE'),
                    key: 'actionType',
                },
                {
                    title: this.$t('WEBSHOPS__USERNAME'),
                    key: 'userName',
                    customTemplate: (item, val) => val ? val : '-'
                },
                {
                    title: this.$t('WEBSHOPS__AMOUNT'),
                    key: 'amount',
                    customTemplate: (item, val) => val + ' ' + this.webshopCurrency
                },
            ],
            dataCount: 0,
            gridData: [],
            loading: true,
        }
    },
    methods: {
        getData() {
            this.loading = true
            var toDate = new Date(this.requestParams.ToDate)
            toDate.setDate(toDate.getDate() + 1) // add one day
            toDate = this.requestParams.ToDate ? subtractHours(toDate, 2) : ''
            axios
                .get('WebShop/GetWebShopAccountStatement', {params : {
                    WebShopId: this.requestParams.WebShopId,
                    StartDate: subtractHours(this.requestParams.StartDate, 2),
                    ToDate: toDate,
                    CurrentPage: this.requestParams.CurrentPage,
                    PageSize: this.requestParams.PageSize,
                }})
                .then(resp => {
                    if(resp.data.status == 1) {
                        let response = resp.data.response
                        this.gridData = response
                        this.dataCount = response.length > 0
                            ? response[0].count
                            : 0
                        this.loading = false
                    }
                })
        },
        pageChangeHandler(page) {
            this.requestParams.CurrentPage = page
            this.getData()
        },
    },
    computed: {
        isSupervisor() {
            return this.$store.state.shop
        },
        webshopOptions() {
            var options = []
            this.$store.state.webshops.forEach(shop => {
                let title = shop.name
                    ? `${shop.calculatedName} (${shop.name})`
                    : shop.calculatedName
                options.push({ title: title, value: shop.id + '' })
            })
            return options
        },
    }
}
</script>

<style lang="scss" scoped>
    form {
        margin-top: 30 * $rem;
        display: flex;
        align-items: center;
        margin-bottom: 15 * $rem;
        max-width: 1000 * $rem;

        .select-wrapper, label {
            margin-right: 15 * $rem;
        }
    }
</style>